import PropTypes from 'prop-types';
import React, {useEffect, useState, useMemo} from 'react';
import {Helmet} from 'react-helmet';
import {Chip, Grid, Paper, Toolbar, Typography} from '@material-ui/core';
import {debounce} from 'throttle-debounce';
import {convertToObjectByKey} from '@ozgene/gp5.utils.array-functions';
import ProjectList from 'Projects/components/ProjectList';
import ProjectProperties from 'Projects/components/ProjectProperties';
import Loader from 'util/Loader';
import {findProjects, importProject} from 'Projects/service/ProjectService';

export default function ProjectLobbyView(props, context) {
  const {router} = context;
  const {location} = props;
  const {
    query: {projectFilterText = '', dateFilterText = ''},
  } = location;
  const decodedProjectFilterText = decodeURIComponent(projectFilterText);
  const decodedDateFilterText = decodeURIComponent(dateFilterText);
  const [selectedProjectId, setSelectedProjectId] = useState();
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const projectsById = useMemo(() => convertToObjectByKey(projects, 'id'), [projects]);
  const selectedProject = useMemo(
    () => projectsById[selectedProjectId],
    [selectedProjectId, projectsById],
  );
  const handleProjectImport = async () => {
    await importProject(selectedProject);
    setProjects((projects) => projects.filter((project) => selectedProject.id !== project.id));
    setSelectedProjectId();

    router.push({pathname: `/mockup/customiseProject/${selectedProject.id}`});
  };
  const handleSelectionChange = (selection) => {
    if (!!selection && selection.length > 0) {
      setSelectedProjectId(selection[selection.length - 1]);
    } else {
      setSelectedProjectId();
    }
  };
  const handleChangeProjectFilterText = debounce(1000, (filterText) => {
    const {
      location: {pathname, query: oldQuery},
    } = props;
    const query = {...oldQuery};

    if (!!filterText) {
      query.projectFilterText = encodeURIComponent(filterText);
    } else {
      delete query.projectFilterText;
    }

    router.replace({pathname, query});
  });
  const handleChangeDateFilterText = debounce(1000, (filterText) => {
    const {
      location: {pathname, query: oldQuery},
    } = props;
    const query = {...oldQuery};

    if (!!filterText) {
      query.dateFilterText = encodeURIComponent(filterText);
    } else {
      delete query.dateFilterText;
    }

    router.replace({pathname, query});
  });

  useEffect(() => {
    const handleRetrieveProjects = async () => {
      const projects = await findProjects();

      setProjects(projects);
      setIsLoading(false);
    };

    if (isLoading) {
      handleRetrieveProjects();
    }
  }, [isLoading]);

  return (
    <>
      <Helmet title="Import Projects" defer={false} />
      <Grid container spacing={2}>
        <Grid item xs={8} md={9}>
          <Paper>
            <Toolbar>
              <Typography style={{color: 'grey'}} variant="h5">
                Import Project Lobby
              </Typography>

              <Chip style={{marginLeft: 30}} variant="outlined" label={projects.length} />
            </Toolbar>
            {isLoading ? (
              <Loader label="Loading Projects..." />
            ) : (
              <ProjectList
                projects={projects}
                onSelectionChange={handleSelectionChange}
                projectFilterText={decodedProjectFilterText}
                dateFilterText={decodedDateFilterText}
                onChangeProjectFilterText={handleChangeProjectFilterText}
                onChangeDateFilterText={handleChangeDateFilterText}
                selectedId={selectedProjectId}
              />
            )}
          </Paper>
        </Grid>
        {!isLoading && (
          <Grid item xs={4} md={3}>
            <ProjectProperties
              onProjectImport={handleProjectImport}
              projects={projects}
              selectedProject={selectedProject}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}

ProjectLobbyView.propTypes = {
  location: PropTypes.object.isRequired,
  params: PropTypes.object,
};

ProjectLobbyView.contextTypes = {
  router: PropTypes.object.isRequired,
};
